// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    timeOut: 300,
    countdown: 20,
    entityLength: 30,
    paymentListTableRows: 20,
    editorToolbarConfig: [
      "heading",
      "bold",
      "italic",
      "bulletedList",
      "numberedList"
    ],
    // Limit and LK error codes
    limitsErrorCodes: [
      "CS0021",
      "CS0022",
      "CS0023",
      "CS0024",
      "CS0025",
      "CS0026",
      "LK0001"
    ],
    CURRENCY_EXCHANGE_PAYMENT_DETAILS: "Currency exchange",
    BETWEEN_OWN_ACCOUNTS_PAYMENT_DETAILS: "Transfer between own accounts",
    DEV_REG_QR_SCAN_TIMEOUT: 2, // In minutes
    DEV_REG_SCAN_POLL_INTERVAL: 60, // in seconds
    LOGIN_MOB_AUTH_CODE_EXPIRY_TIMEOUT: 120,
    MOB_AUTH_CODE_POLLING_TIMEOUT: 1000, // time ouit for API
    MOB_AUTH_CODE_EXPIRY_TIMEOUT:2, // In minutes
    MOB_AUTH_CODE_CHECK_INTERVAL: 60, // In Seconds
    enableSCA: true,
    enableInviteUser: true,
    env: 'dev',
    enableMerchantApi: true
  };
  
  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/dist/zone-error';  // Included with Angular CLI.
  